<template>
    <div class="room-size-selector">
        <p class="room-size-selector__label">{{ dictionary.BookingFlowRoomsSizeSelectorLabel }}</p>
        <Slider v-model="sizes" range :min="minimumSize" :max="maximumSize" @slideend="handleSizeChange(sizes)" />
        <div class="room-size-selector__ranges">
            <div>{{ minimumShowSize }} <span v-html="unitShowValue"></span></div>
            <div><b>Viser {{ showSizes[0] }} til {{ showSizes[1] }} <span v-html="unitShowValue"></span></b></div>
            <div>{{ maximumShowSize }} <span v-html="unitShowValue"></span></div>
        </div>
    </div>
</template>
<script>

import Slider from 'primevue/slider';
import Button from 'primevue/button';
export default {
    name: "roomSizeSelector",
    props: ["initialMin", "initialMax", "minimum", "maximum", "unit", "dictionary"],
    components: {
        Slider,
        Button
    },
    data() {
        return {
            sizes: [0, 99],
            minimumSize: 0,
            maximumSize: 10,
            minimumShowSize: 0,
            maximumShowSize: 10,
            unitShowValue: "m<sup>2<sup>",
            showSizes: [0, 99]
        };
    },
    created() {
        const vm = this;
        if (vm.minimum >= 0) {
            vm.minimumSize = Math.floor(vm.minimum);
            vm.minimumShowSize = vm.minimumSize;
        }
        if (vm.maximum > 0) {
            vm.maximumSize = Math.ceil(vm.maximum);
            if (vm.maximumSize > 10) {
                vm.maximumSize = 10;
            }
            vm.maximumShowSize = vm.maximumSize;

        }
        if (vm.initialMin >= 0 && vm.initialMax > 0) {
            vm.handleSizeChange([Math.floor(vm.initialMin), Math.floor(vm.initialMax)]);
        }
    },
    methods: {
        handleSizeChange(size) {
            const vm = this;
            if (size && size.length == 2) {
                //Make sure they are not the same
                if(size[0] == size[1]){
                    if(size[0] == vm.maximumSize){
                        size[0]--;
                    }else {
                        size[1]++;

                    }
                }
                vm.sizes = size;
            }
            vm.$emit('sliderChanged', vm.sizes);
            this.updateShowValue();
        },
        updateShowValue() {
            const vm = this;
            switch (vm.unit) {
                case "volume":
                    vm.minimumShowSize = (vm.minimumSize * 2.7).toFixed(1);
                    vm.maximumShowSize = (vm.maximumSize * 2.7).toFixed(1);
                    if (vm.maximumShowSize == 27) {
                        vm.maximumShowSize += '+';
                    }
                    for (let i = 0; i < vm.sizes.length; i++) {
                        vm.showSizes[i] = (vm.sizes[i] * 2.7).toFixed(1);

                        if(i == 1 && vm.showSizes[i] == 27){
                            vm.showSizes[i] += '+';
                        }
                    }
                    vm.unitShowValue = "m<sup>3<sup>";
                    break;
                case "area":
                default:
                    vm.minimumShowSize = vm.minimumSize;
                    vm.maximumShowSize = vm.maximumSize;
                    if (vm.maximumShowSize == 10) {
                        vm.maximumShowSize += '+';
                    }
                    for (let i = 0; i < vm.sizes.length; i++) {
                        vm.showSizes[i] = vm.sizes[i]

                        if(i == 1 && vm.showSizes[i] == 10){
                            vm.showSizes[i] += '+';
                        }
                    }
                    vm.unitShowValue = "m<sup>2<sup>"
                    break;
            }
        }
    },
    watch: {
        sizes(newSize, oldSize) {
            this.updateShowValue();
        },
        unit(newUnit, oldUnit) {
            this.updateShowValue();
        }
    }
};
</script>
